<template>
  <main id="main">
    <div class="p-3 pb-6">
      <div class="bg_white rounded-pill p-2 d-flex align-items-center shadow position-sticky top-0" style="z-index: 1000;">
        <img style="width: 5rem; height: 5rem" :src="userInfo.pic || require('@/assets/imgs/NoPath - Copy.svg')" class="rounded-pill border_theme ms-3" alt="">
        <p class="text_color_theme ms-2 bold">{{ userInfo.name }}</p>
        <p class="bold">{{ t('hello_dear') }}</p>
      </div>

      <div v-if="slider.length > 0" class="slider-container mt-4">
        <swiper
          :effect="'cube'"
          :grabCursor="true"
          :cubeEffect="{
            shadow: true,
            slideShadows: true,
            shadowOffset: 20,
            shadowScale: 0.94,
          }"
          :pagination="{ clickable: true }"
          :autoplay="{
            delay: 4000,
            disableOnInteraction: false,
          }"
          :loop="true"
          :modules="modules"
          class="mySwiper"
        >
          <swiper-slide v-for="(slide, index) in slider" :key="index">
            <img :src="slide.pic" class="slider-image" alt="Slider Image"/>
          </swiper-slide>
        </swiper>
      </div>

      <div class="d-flex justify-content-between align-items-center my-4">
        <p class="bold">{{ t('grades') }}</p>
        <div class="d-flex align-items-center gap-3" @click="$router.push({ name: 'GradesList' })">
          <p>{{ t('view_all') }}</p>
          <img src="@/assets/imgs/bg_arrow.svg" class="icon-size-4" alt="">
        </div>
      </div>

      <div class="d-flex align-items-center gap-3 overflow-x-scroll w-100 pb-4">
        <div v-for="grade in grades" :key="grade.id" class="custom_card" @click="$router.push({ name: 'GradeCourses', params: { gradeId: grade.id } })">
          <div class="bg_white rounded-5 p-3 shadow_box w-100">
            <img style="width: 100%; height: 6rem" :src="grade.pic" alt="">
          </div>
          <div class="bg_white rounded-pill p-3 shadow_box w-100">
            <p class="text-center w-100">{{ grade.title }}</p>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between mt-3">
        <div class="bg_orange inner_shadow_box gap-2 w-48 p-3 rounded-5 d-flex align-items-center justify-content-between" @click="openLibraryModal">
          <p class="text_color_white">{{ t('library') }}</p>
          <img src="@/assets/imgs/Group%20432.svg" class="icon-size-4" alt="">
          <img src="@/assets/imgs/LIBRARI.svg" class="icon-size-9" alt="">
        </div>
        <div class="bg_blue inner_shadow_box gap-2 w-48 p-3 rounded-5 d-flex align-items-center justify-content-between" @click="$router.push({ name: 'TeachersList' })">
          <p class="text_color_white">{{ t('teachers_profile') }}</p>
          <img src="@/assets/imgs/Group%20432.svg" class="icon-size-4" alt="">
          <img src="@/assets/imgs/TEACHER.svg" class="icon-size-7" alt="">
        </div>
      </div>

      <div class="mt-4 mb-6">
        <p class="bold mb-4">{{ t('last_seen') }}</p>
        <div v-if="latestSeen.length > 0">
          <div v-for="(item, index) in latestSeen" :key="index" class="d-flex align-items-center justify-content-between shadow_box rounded-4 bg_white p-2 mb-3" @click="$router.push({ name: 'LessonDetail', params: { id: item.content_id || item.id } })">
            <div class="d-flex align-items-center gap-1">
              <img :src="item.pic || require('@/assets/imgs/NoPath - Copy (5).png')" class="icon-size-7 rounded-4" alt="">
              <p>{{ item.lesson_title }}</p><p>-</p><p>{{ item.content_title }}</p>
            </div>
            <div class="d-flex align-items-center gap-3">
              <p class="text_color_theme">{{ item.status || 'ادامه' }}</p>
              <img src="@/assets/imgs/play.svg" class="icon-size-4" alt="">
            </div>
          </div>
        </div>
        <div v-else class="text-center text_color_gray mt-3">
           {{ t('empty_list') }}
        </div>
      </div>
    </div>

    <BottomNav />

    <div v-if="showModal" class="modal_overlay">
      <div class="modal_content">
        <div class="d-flex justify-content-center mb-3 position-relative">
           <div class="icon_circle">
             <img src="@/assets/imgs/knowledge_1.svg" class="modal_img" alt="">
           </div>
        </div>
        <p class="text_color_theme bold text-center font_large mb-3">جمله انگیزشی امروز</p>
        <p class="text-center font_normal mb-5 line_height_2 px-2">{{ dailySentence }}</p>
        <button class="modal_btn" @click="showModal = false">{{ t('understand') }}</button>
      </div>
    </div>

    <div v-if="showLibraryModal" class="modal_overlay">
      <div class="modal_content">
        <div class="d-flex justify-content-center mb-3 position-relative">
           <div class="icon_circle">
             <img src="@/assets/imgs/LIBRARI.svg" class="modal_img" alt="">
           </div>
        </div>
        <p class="text-center font_normal mb-5 line_height_2 px-2 mt-4">{{ libraryMessage }}</p>
        <button class="modal_btn" @click="showLibraryModal = false">{{ libraryButtonText }}</button>
      </div>
    </div>

    <div v-if="showExitModal" class="modal_overlay">
      <div class="modal_content">
        <p class="text-center font_normal bold mb-5 mt-4">{{ t('exit_confirm_title') }}</p>
        <div class="d-flex flex-column gap-3 w-100">
          <button class="modal_btn bg_red_btn" @click="exitApp">{{ t('yes_exit') }}</button>
          <button class="modal_btn bg_white_btn" @click="closeExitModal">{{ t('no_stay') }}</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import BottomNav from '@/components/BottomNav.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/effect-cube'
import 'swiper/css/pagination'
import { EffectCube, Pagination, Autoplay } from 'swiper/modules'

export default {
  name: 'HomeView',
  components: {
    BottomNav,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      showModal: false,
      showLibraryModal: false,
      showExitModal: false,
      dailySentence: '',
      libraryMessage: '',
      libraryButtonText: '',
      userInfo: {
        name: '',
        pic: ''
      },
      slider: [],
      grades: [],
      latestSeen: []
    }
  },
  setup() {
    return {
      modules: [EffectCube, Pagination, Autoplay],
    }
  },
  mounted() {
    this.fetchHomeData()
    history.pushState(history.state, '', location.href)
    window.onpopstate = this.handleBackEvent
  },
  beforeUnmount() {
    window.onpopstate = null
  },
  methods: {
    handleBackEvent() {
      history.pushState(history.state, '', location.href)
      this.showExitModal = true
    },
    closeExitModal() {
      this.showExitModal = false
    },
    exitApp() {
      try {
        if (navigator.app && navigator.app.exitApp) {
          navigator.app.exitApp()
        } else if (navigator.device && navigator.device.exitApp) {
          navigator.device.exitApp()
        } else {
          window.open('', '_self', '')
          window.close()
          
          setTimeout(() => {
            window.location.href = "https://www.google.com"
          }, 100)
        }
      } catch (e) {
        window.location.href = "https://www.google.com"
      }
    },
    openLibraryModal() {
      const lang = localStorage.getItem('app_lang')
      
      if (lang === 'ps') {
        this.libraryMessage = 'دا برخه فعلا د لاسرسي وړ نده'
        this.libraryButtonText = 'پوه شوم'
      } else {
        this.libraryMessage = 'این قسمت فعلاً در دسترس نیست'
        this.libraryButtonText = 'فهمیدم'
      }
      
      this.showLibraryModal = true
    },
    async fetchHomeData() {
      try {
        const userId = localStorage.getItem('user_id')
        
        const formData = createFormData({ 
          user_id: userId
        })
        
        const response = await apiClient.post('/home_page', formData)
        
        if (response.data.status === 'ok' && response.data.data) {
          const data = response.data.data

          let serverPic = data.profile_pic
          const localPic = localStorage.getItem('temp_profile_pic')

          if ((!serverPic || serverPic.includes('nopic') || serverPic === '') && localPic) {
             serverPic = localPic
          }

          this.userInfo.name = data.user_info || ''
          this.userInfo.pic = serverPic

          this.slider = data.slider || []

          this.grades = data.grades || []
          this.latestSeen = data.latest_seen || []

          if (data.sentence) {
            this.dailySentence = data.sentence
            const hasSeenSentence = sessionStorage.getItem('hasSeenDailySentence')
            if (!hasSeenSentence) {
              this.showModal = true
              sessionStorage.setItem('hasSeenDailySentence', 'true')
            }
          }
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.slider-container {
  width: 100%;
  height: 23rem;
  border-radius: 1.5rem;
  overflow: hidden;
}

.mySwiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
}

.slider-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.custom_card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-width: 8rem;
  height: 13rem;
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_content {
  background-color: white;
  width: 85%;
  max-width: 25rem;
  border-radius: 2.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: fadeIn 0.3s ease-out;
}
.icon_circle {
  background-color: #f0f8ff; 
  border-radius: 50%;
  padding: 1rem;
  width: 7rem;
  height: 7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -4rem;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  background: white;
}
.modal_img {
  width: 4rem;
  height: 4rem;
}
.modal_btn {
  background: linear-gradient(90deg, #8E2DE2 0%, #4A00E0 100%);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 1rem 0;
  font-weight: bold;
  font-size: 1.1rem;
  box-shadow: 0 5px 15px rgba(74, 0, 224, 0.4);
  cursor: pointer;
  width: 100%;
  transition: transform 0.2s;
}
.bg_red_btn {
  background: #FF0000 !important;
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.2) !important;
}
.bg_white_btn {
  background: #FFFFFF !important;
  color: #000000 !important;
  border: 1px solid #E0E0E0;
  box-shadow: none !important;
}
.modal_btn:active {
  transform: scale(0.98);
}
.line_height_2 {
  line-height: 2rem;
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
</style>